import type { Segment, StageInput } from "../types/api";

export interface FlowPreset {
  id: string;
  name: string;
  description: string;
  segmentHints: Segment[];
  stages: StageInput[];
}

export const BUILTIN_FLOW_PRESETS: FlowPreset[] = [
  {
    id: "standard_bpo",
    name: "Standard BPO",
    description: "Full pipeline for voice and BPO roles — screening through ops.",
    segmentHints: ["bpo_ops"],
    stages: [
      { name: "Screening", stage_type: "screening", is_mandatory: true },
      { name: "Assessment 1", stage_type: "assessment", is_mandatory: true },
      { name: "Interview", stage_type: "interview", is_mandatory: true },
      { name: "Ops Round", stage_type: "ops", is_mandatory: true },
    ],
  },
  {
    id: "fast_track",
    name: "Fast Track",
    description: "Quick two-step flow when volume hiring and HR is on every call.",
    segmentHints: ["bpo_ops"],
    stages: [
      { name: "Screening", stage_type: "screening", is_mandatory: true },
      { name: "Interview", stage_type: "interview", is_mandatory: true },
    ],
  },
  {
    id: "chat_support",
    name: "Chat Support",
    description: "Written communication focus with typing assessment.",
    segmentHints: ["bpo_ops"],
    stages: [
      { name: "Screening", stage_type: "screening", is_mandatory: true },
      { name: "Typing Test", stage_type: "assessment", is_mandatory: true },
      { name: "Interview", stage_type: "interview", is_mandatory: true },
    ],
  },
  {
    id: "it_tech",
    name: "IT / Tech",
    description: "Technical screening and assessment for IT support roles.",
    segmentHints: ["tech"],
    stages: [
      { name: "Screening", stage_type: "screening", is_mandatory: true },
      { name: "Technical Assessment", stage_type: "assessment", is_mandatory: true },
      { name: "Interview", stage_type: "interview", is_mandatory: true },
      { name: "Ops Round", stage_type: "ops", is_mandatory: true },
    ],
  },
  {
    id: "design_creative",
    name: "Design / Creative",
    description: "Portfolio-first flow for creative and design hires.",
    segmentHints: ["creative"],
    stages: [
      { name: "Portfolio Review", stage_type: "screening", is_mandatory: true },
      { name: "Interview", stage_type: "interview", is_mandatory: true },
      { name: "Ops Round", stage_type: "ops", is_mandatory: true },
    ],
  },
];

export const SCRATCH_PRESET_ID = "scratch";

export const SCRATCH_PRESET: FlowPreset = {
  id: SCRATCH_PRESET_ID,
  name: "Start from scratch",
  description: "Build a custom flow stage by stage.",
  segmentHints: [],
  stages: [],
};

export function getPresetStages(presetId: string): StageInput[] {
  if (presetId === SCRATCH_PRESET_ID) return [];
  const preset = BUILTIN_FLOW_PRESETS.find((p) => p.id === presetId);
  return preset ? preset.stages.map((s) => ({ ...s })) : [];
}

export const DEFAULT_PRESET_ID = "standard_bpo";
